// src/context/AuthContext.jsx
import React, { createContext, useContext, useState, useEffect } from 'react';
import { apiMe, setToken, clearToken, getToken } from '../services/api';

const AuthContext = createContext(null);

const COOKIE_AUTH = process.env.REACT_APP_COOKIE_AUTH !== 'false';

export function AuthProvider({ children }) {
  const [user, setUser]       = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // On mount — verify session is still valid.
    // Cookie mode: no token in storage to check — always ask the backend,
    // since the so_session cookie (if any) is sent automatically.
    // Legacy mode: skip the network call entirely if there's no stored token.
    const verify = async () => {
      if (!COOKIE_AUTH) {
        const token = getToken();
        if (!token) { setLoading(false); return; }
      }
      try {
        const data = await apiMe();
        if (data?.user) setUser(data.user);
        else if (!COOKIE_AUTH) clearToken();
      } catch {
        if (!COOKIE_AUTH) clearToken();
      } finally {
        setLoading(false);
      }
    };
    verify();
  }, []);

  const login = (userData, token, keepLoggedIn) => {
    if (token) setToken(token, keepLoggedIn);
    if (keepLoggedIn) {
      localStorage.setItem('ca_user', JSON.stringify(userData));
    } else {
      sessionStorage.setItem('ca_user', JSON.stringify(userData));
    }
    setUser(userData);
  };

  const logout = () => {
    clearToken();
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);